<template>
  <div class="device">
    <a-spin :spinning="spinning">
    <!-- ----------------- -->
    <div class="device-title">
      开锁记录
    </div>
    <!-- 搜索 -->
    <div class="serach-warp">
      <div class="margin-right-15" style="display: inline-block;vertical-align: top;">
        <search @onSearch="onSearch" :placeholder="searchPlaceholder" />
      </div>
    </div>
    <!-- 表格 -->
    <device-table ref="deviceTable" />
    </a-spin>
  </div>
</template>

<script>
import search from "@/components/content/search/Search";
import DeviceTable from './childComps/FeedbackTable';
import { hasPermission } from 'utils/hasPermission'

export default {
  name: 'Device',
  components: {
    search,
    DeviceTable
  },
  data() {
    return {
      spinning: false,
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
      },
      visible: false,

      createDeviceForm: {
        cmd: null,
        cmdDate: null,
        name: "",
        pos: "",
        state: 0,
        vptNum: "",
      },
    }
  },
  computed: {
    searchPlaceholder() {
      const isCustomerView = !hasPermission('/feedback/column/vptNum')
        && !hasPermission('/feedback/column/name')
        && (hasPermission('/feedback/column/vptCode')
          || hasPermission('/feedback/column/pos')
          || hasPermission('/feedback/column/createBy'))
      return isCustomerView
        ? '请输入站点编码、地理位置或操作人搜索'
        : '请输入设备编码或IMEI搜索'
    }
  },
  methods: {
    /**
    * 逻辑区
    */
    // 加载动画
    loading() {
      this.spinning = !this.spinning
    },
    // 搜索
    onSearch(value) {
      this.$refs.deviceTable.deviceName = value;
      this.$refs.deviceTable.getDeviceListData(1, this.pageSize, value)
    }
  }
}
</script>

<style lang='scss' scoped>
  .device {
    .device-title {
      font-size: 30px;
      font-weight: 500;
      color: #131212;
    }
    .serach-warp {
      margin: 15px 0;
      .createrBtn {
        color: #fff;
        background-color:rgba($color: #E84D11, $alpha: .6)
      }
    }
  }

  .createTitle {
    line-height: 45px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    color: #131212;
    margin-bottom: 30px;
  }
  .btn-wrap {
    text-align: center;
    margin-top: 10px;
    .create {
      color: #fff;
      background-color: #E84D11;
    }
  }
</style>
